import { Country } from './others.model';
import { PaginationRequestParams } from './pagination.model';

export const COMPOSER_ROLE_ID = 4;
export const ARTIST_ROLE_ID = 1;

export interface Person<F = PersonEdition> {
    id?: number;
    image: string;
    firstName: string;
    lastName?: string;
    description?: string;
    excerpt?: string;
    homeCountry?: Country;
    roles?: PersonRole[];
    images?: GalleryItem[];
    finals?: F[];
    rolesId?: number[];
    isFavorite?: boolean;
    _similarTo?: number[];
}

export interface PersonRole {
    id: number;
    name: string;
}

export interface PersonEdition {
    edition: {
        id: number;
        year: string;
        name: string;
    };
    place: number;
}

export interface EditionFinalist {
    finalist: Person<string>;
    place: number;
    _editionId?: number;
}

export interface GalleryItem {
    id: number;
    thumb: string;
    orginalUrl: string;
}

export interface PeopleRequestParams extends PaginationRequestParams {
    isFavorite?: boolean;
    roles?: number[];
    _isolatedMetaKey?: string;
}
